var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 18"}},_vm.$listeners),[_c('path',{attrs:{"d":"M0 1.1L16 1M0 16.6l24-.1M0 8.6l24-.1","fill":"none","stroke":"#264057","stroke-width":"1.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }